export default __webpack_public_path__ + "static/media/large_trash.bd2f8e48.svg";